import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

const RiskReversalSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.02067 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0226H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M32.4626 23.9435L21.4476 19.0924H15.2649L12.873 18.0226" stroke="#A40C0C" strokeWidth="2"/>
        <path d="M1.28941 12.8418L12.873 18.0226" stroke="#089981" strokeWidth="2"/>
    </svg>
)
const RiskReversal: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {RiskReversalSvg(props)}
    </SvgIcon>
));
export default RiskReversal